module.exports = __webpack_public_path__ + "static/ma-8-sq-f5008a97f4dfcef9e8a5efa5df06f56c.png";